import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

export function StatCard({ label, value, hint, trend, trendDir, testId }) {
  const up = trendDir === "up";
  return (
    <div
      data-testid={testId}
      className="rounded-lg border border-zinc-800/70 bg-[#121214] p-4 transition-colors hover:border-zinc-700"
    >
      <div className="flex items-center justify-between">
        <span className="label-caps">{label}</span>
        {trend != null && (
          <span
            className={`inline-flex items-center gap-1 text-[11px] font-medium ${
              up ? "text-emerald-400" : "text-red-400"
            }`}
          >
            {up ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
            {trend}
          </span>
        )}
      </div>
      <div className="mt-2 text-2xl font-semibold tracking-tight text-zinc-50">
        {value}
      </div>
      <div className="mt-1 text-[12px] text-zinc-500">{hint}</div>
    </div>
  );
}
